import vue from 'vue'
const that = vue.prototype
export default {
  className: 'turntableSettings',
  fields: [
    {
      name: 'prize',
      validators: [
        (val) => val ? null : '奖品名称不可为空',
        (val) => {
          let status = false
          const regChinese = /^[\u3400-\u4DB5\u4E00-\u9FEA\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29\u{20000}-\u{2A6D6}\u{2A700}-\u{2B734}\u{2B740}-\u{2B81D}\u{2B820}-\u{2CEA1}\u{2CEB0}-\u{2EBE0}]{1,}$/u
          for (let i = 0; i < val.length; i++) {
            if (!regChinese.test(val[i])) {
              status = true
            }
          }
          if (status) {
            return '奖品名称必须为中文'
          }
        },
        (val) => {
          if (val.length > 4) {
            return '奖品名称不能超过四个字符'
          }
        }
      ],
      tooltip: '奖品名称不能超过四个字符，且必须为汉字'
    },
    {
      name: 'probability',
      validators: [
        (val) => val ? null : '转盘概率不可为空'
      ],
      tooltip: '转盘抽奖概率合计不能大于100，小数会按百分数处理，小数最多两位'
    }
  ],
  search: [
    'prize'
  ],
  hooks: {
    async beforeSave (options) {
      let data = options.data
      let turntableList = await that.$modelAjax.getList(`turntableSettings`)
      if (options.objectId && turntableList.length > 8) {
        throw that.$notification['error']({
          message: '转盘设置超过最大限制',
          description: '保存失败'
        })
      }
      if (!options.objectId && turntableList.length > 7) {
        throw that.$notification['error']({
          message: '转盘设置超过最大限制',
          description: '保存失败'
        })
      }
      // 判断转盘设置概率是否超出范围
      let num = 0
      if (!options.objectId) {
        turntableList.forEach(s => {
          if (!s.probability) {
            s.probability = 0
          }
          num += s.probability
        })
        if ((num + data.probability) > 100) {
          throw that.$notification['error']({
            message: '转盘抽奖概率合计不能大于100',
            description: '保存失败'
          })
        }
      } else {
        if (!data.probability) { data.probability = 0 }
        let index = turntableList.findIndex(s => { return s.objectId === options.objectId })
        turntableList[index].probability = data.probability
        turntableList.forEach(s => {
          if (!s.probability) {
            s.probability = 0
          }
          num += s.probability
        })
        if (num > 100) {
          throw that.$notification['error']({
            message: '转盘抽奖概率合计不能大于100',
            description: '保存失败'
          })
        }
      }
    }
  }
}
